export const vulnTrendChartConstants = {
  TOOLTIP_TPL_DOT: 'views/tooltips/cs-vuln-trend-chart-tooltip-dot.html',
  TOOLTIP_TPL_CONNECTOR:
    'components/vulnerabilities/cs-vuln-trend-chart-tooltip-connector.html',
  TIME_FORMAT: '%b %e',
  Y_AXIS_MAX_PAD: 1,
  Y_AXIS_MIN_PAD: -1,
  TRANSLATE_X: 30,
  TRANSLATE_Y: 10,
  DOT_RADIUS: 6,
  DOT_RADIUS_MINI: 4,
  CLOSED_COLOR: '#3A3A3A',
  OPEN_COLOR: '#AFCB4E',
  CONNECTOR_LINE_COLOR: '#B3B3B3',
  OPEN: 'open',
  CLOSED: 'closed',
  TOP: 'top',
  BOTTOM: 'bottom',
  CUSTOM_X_AXIS: 'custom-x-axis',
  CUSTOM_CONNECTOR: 'custom-vertical-line-group',
  DOT_X_PREFIX: 'dot-x',
  GROUP_X_PREFIX: 'group-x-',
  ACTIVE: 'active',
  SHOW: 'show',
  HIDE: 'hide',
  LOADING: 'loading',
  CLOSED_VULN: 'closed-vuln',
  DELIM: '~',
  VULN_TREND_CHART: 'vuln-trend-chart',
  CHART_TOOLTIP: 'chart-tooltip',
  CONNECTOR_INFO: 'connector-info',
  SWAP_Y_OFFSET: 6,
  RENDER_DELAY: 300,
  HOVER_AREA_STROKE_WIDTH_NORMAL: 20
}
